import React from "react";
import MasterData from "view/settings/masterdata/MasterData";

const CommercialRevenueLeasing = () => {
    
    const sections = [
        { label: "Status", value: "Status", items: [] },
        { label: "Partner Name", value: "partnerName", items: [] },
        { label: "Revenue Model", value: "revenueModel", items: [] },
        { label: "Asset Name", value: "assetName", items: [] },
    ];

    return (
        <MasterData pageTitle="Commercial" sections={sections} />
    );
};

export default CommercialRevenueLeasing;